import React from 'react';

const PlusButton = props => {
    const {
        callback,
        disabled
    } = props

    let className = "plus-button"
    
    if(disabled){
        className += ' disabled'
    }

    return (
        <div onClick={callback} className={className} />
    )
};

export default PlusButton;
